type Address = {
  line1?: string;
  line2?: string;
  line3?: string;
  line4?: string;
  locality?: string;
  town?: string;
  county?: string;
  postcode?: string;
};

export default function getAddress(obj: Address): string {
  let address = "";

  if (obj.line1) {
    address += `${obj.line1}, `;
  }

  if (obj.line2) {
    address += `${obj.line2}, `;
  }

  if (obj.line3) {
    address += `${obj.line3}, `;
  }

  if (obj.line4) {
    address += `${obj.line4}, `;
  }

  if (obj.locality) {
    address += `${obj.locality}, `;
  }

  if (obj.town) {
    address += `${obj.town}, `;
  }

  if (obj.county) {
    address += `${obj.county}, `;
  }

  if (obj.postcode) {
    address += `${obj.postcode}`;
  }

  return address;
}
